export default function logGoogleTagManagerEvent(event: { [key: string]: any }) {
	if ('dataLayer' in window) {
		(window as unknown as { dataLayer: { [key: string]: any } }).dataLayer.push(event);
	}
}
